import { CmsGrid } from '../../../components/cms/CmsGrid';
import { CmsRibbon } from '../../../components/cms/CmsRibbon';
import { Theme } from '../../../config/theme';
import { CardSizeInfo } from '../CardSizeInfo';
import { CardDataSource } from '../CardDataSource';
import { LLDataSource } from '../LLDataSource';
import { Backend } from '../../../api/Backend';
import { ICustomPage, ICustomSearchRow, ISearchElementListV3 } from '../../../api/models/AndromeTV.types';
import { AssetType } from '../../../api/models/Shared.types';
import { ChannelModel } from '../../../api/EpgApi.types';
import { SearchApi } from '../../../api/SearchApi';

const _constants = {
  firstLoadAmount: 6,
  loadAmount: 3,
};

export class SearchRowDataSource extends LLDataSource {
  private assetType: AssetType | string;
  private properties: string[];
  private rowInfo: ICustomSearchRow | undefined;
  private data: ISearchElementListV3;
  private isGrid: boolean;
  private sizeInfo: CardSizeInfo;
  private title: string | undefined;
  private message = false;
  private channels: ChannelModel[];
  private requestParams?: any;

  constructor(
    backend: Backend,
    page: ICustomPage,
    data: ISearchElementListV3,
    isGrid: boolean,
    channels: ChannelModel[] = [],
    requestParams?: any
  ) {
    super(backend, _constants.firstLoadAmount, _constants.loadAmount);
    this.assetType = data.type;
    this.properties = page.searchPage?.properties || [];
    this.rowInfo = page.searchPage?.rows?.find(r => r.type === data.type);
    this.data = data;
    this.isGrid = isGrid;
    this.sizeInfo = new CardSizeInfo(isGrid);
    this.titleHeight = Theme.Fonts.Ribbon.Title.lineHeight;
    this.title = this.rowInfo?.title;
    this.hasNextPage = true;
    this.channels = channels;
    this.requestParams = requestParams;
    if (this.rowInfo?.properties) {
      this.properties = this.properties.concat(this.rowInfo.properties);
    }
  }

  override load(): Promise<SearchRowDataSource> {
    return new Promise(resolve => {
      if (!this.hasNextPage) {
        resolve(this);
        return;
      }
      if (this.data) {
        // console.log('SearchRowDataSource', this, this.data);
        this.sizeInfo.updateWithContainer(this.data.elements, this.properties);
        if (this.data.elements.items) {
          this.items = this.items.concat(
            this.data.elements.items.map(
              card => new CardDataSource(this.backend, card, this.sizeInfo, this.properties, this.channels)
            )
          );
        }
        this.pageIdx = 1;
        this.hasNextPage = this.data.elements.nextPage;
      }
      resolve(this);
    });
  }

  override isEmpty(): boolean {
    return super.isEmpty() && !this.message;
  }

  totalHeight(): number {
    return this.titleHeight + this.sizeInfo.height;
  }

  override componentDescription() {
    if (this.isGrid) {
      return {
        focusable: true,
        type: CmsGrid,
        data: this,
      };
    } else {
      return {
        focusable: true,
        type: CmsRibbon,
        data: this,
        h: this.totalHeight(),
      };
    }
  }

  _fetchPage(pageIdx: number): Promise<unknown> {
    return SearchApi.search(
      this.backend,
      this.requestParams.searchTerm,
      [this.data.type as AssetType],
      this.requestParams.adult,
      this.requestParams.catalogId,
      false,
      pageIdx,
      this.requestParams.extraData
    ).then(res => {
      const foundRow = res.results ? res.results[0] : undefined;
      if (foundRow?.elements.items) {
        this.items = this.items.concat(
          foundRow.elements.items.map(
            card => new CardDataSource(this.backend, card, this.sizeInfo, this.properties, this.channels)
          )
        );
      }
      this.hasNextPage = foundRow?.elements.nextPage;
    });
  }
}
